import React, { Component } from "react";

class SelectorWidgetMobile extends Component {
  render() {
    let {
      endIcon,
      dottedLine,
      startIcon,
      renderStoresSelector,
      onStoreSet,
      errorMessage,
      bathroom,
      redbanc,
      dd,
      info,
      milk,
      elevator,
      parking,
      casino,
      cafeteria,
      config
    } = this.props;
    return (
      <div className="card card-1 pt-3 pb-3 pl-4 pr-4">
        <div
          id="left-container"
          className="float-left route-container"
          style={{ height: "100%" }}
        >
          <img
            alt=""
            style={{ position: "absolute", top: "25px", left: "13px" }}
            src={endIcon}
          />
          <img
            alt=""
            style={{ position: "absolute", top: "51px", left: "19px" }}
            src={dottedLine}
          />
          <img
            alt=""
            style={{ position: "absolute", top: "110px", left: "13px" }}
            src={startIcon}
          />
        </div>
        <div className="card card-1">{renderStoresSelector(true)}</div>
        <div className="card card-1 mt-4">
          {renderStoresSelector(false)}
        </div>
        <div className="services-container">
          <img
            alt=""
            className={ "service-image " + (config.services.filter(f => f === "bathroom")[0] ? "d-inline-block" : "d-none") }
            src={bathroom}
            onClick={() => onStoreSet(true, false, "bathroom")}
          />
          <img
            alt=""
            className={ "service-image " + (config.services.filter(f => f === "casino")[0] ? "d-inline-block" : "d-none") }
            src={casino}
            onClick={() => onStoreSet(true, false, "casino")}
          />
          <img
            alt=""
            className={ "service-image " + (config.services.filter(f => f === "cafeteria")[0] ? "d-inline-block" : "d-none") }
            src={cafeteria}
            onClick={() => onStoreSet(true, false, "cafeteria")}
          />
          <img
            alt=""
            className={ "service-image " + (config.services.filter(f => f === "redbanc")[0] ? "d-inline-block" : "d-none") }
            src={redbanc}
            onClick={() => onStoreSet(true, false, "redbanc")}
          />
          <img
            alt=""
            className={ "service-image " + (config.services.filter(f => f === "dd")[0] ? "d-inline-block" : "d-none") }
            src={dd}
            onClick={() => onStoreSet(true, false, "dd")}
          />
          <img
            alt=""
            className={ "service-image " + (config.services.filter(f => f === "info")[0] ? "d-inline-block" : "d-none") }
            src={info}
            onClick={() => onStoreSet(true, false, "info")}
          />
          <img
            alt=""
            className={ "service-image " + (config.services.filter(f => f === "milk")[0] ? "d-inline-block" : "d-none") }
            src={milk}
            onClick={() => onStoreSet(true, false, "milk")}
          />
          <img
            alt=""
            className={ "service-image " + (config.services.filter(f => f === "elevator")[0] ? "d-inline-block" : "d-none") }
            src={elevator}
            onClick={() => onStoreSet(true, false, "elevator")}
          />
          <img
            alt=""
            className={ "service-image " + (config.services.filter(f => f === "parking")[0] ? "d-inline-block" : "d-none") }
            src={parking}
            onClick={() => onStoreSet(true, false, "parking")}
          />
        </div>
        {errorMessage && (
          <div className="pl-3 pt-1 error-message">{errorMessage}</div>
        )}
      </div>
    );
  }
}

export default SelectorWidgetMobile;


// WEBPACK FOOTER //
// ./src/views/start/SelectorWidgetMobile.js